class Overlay {
  constructor(amount, type, startDate, enabled = true) {
    this.amount = amount;
    this.type = type;
    this.startDate = startDate;
    this.enabled = enabled;
  }
}

module.exports = Overlay;
